import { render } from "./SearchNoResult.vue?vue&type=template&id=abc6f4b0&scoped=true"
import script from "./SearchNoResult.vue?vue&type=script&lang=js"
export * from "./SearchNoResult.vue?vue&type=script&lang=js"

import "./SearchNoResult.vue?vue&type=style&index=0&id=abc6f4b0&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc6f4b0"]])

export default __exports__